import { SADDLE_COLORS } from "@tvg/design-system";
import { SaddleType } from "../../types";

export const exoticSeparator = "-";
export const pickSeparator = "/";
const positionSeparator = ",";

export const parseResults = (
  selections: string,
  typeSeparator: string
): Array<Array<string>> =>
  selections
    .split(typeSeparator)
    .map((sel) => (sel === "" ? sel.replace("", "?") : sel))
    .map((winners) => winners.split(positionSeparator));

export const getSelectionsFromString = (
  selection: string,
  isPick: boolean,
  saddleType: SaddleType
) => {
  // remove double spaces from string ex: "3 OF  3 4-5-6"
  const singleSpacesSelection = selection.replace(/  +/g, " ");
  const pickStr = Object(singleSpacesSelection.match(/\d\sof\s\d/i))[0];
  const isValidSaddleType =
    saddleType.toLocaleLowerCase() === "thoroughbred" ||
    saddleType.toLocaleLowerCase() === "harness";

  // check if a pick bet should use the pick separator
  const isPickBet = isPick && selection.includes("/");

  const selectionArr = parseResults(
    singleSpacesSelection.replace(pickStr, ""),
    isPickBet ? pickSeparator : exoticSeparator
  );

  // TODO remove all filter when DS component supports it

  const filteredSelections = selectionArr
    .map((items) => items.filter((item) => item.toLowerCase() !== "carryover"))
    .filter((selections) => selections.length);

  return filteredSelections.map((items) =>
    items.map((item) => {
      const number = item.replace(/\s/g, "");
      const colors =
        SADDLE_COLORS[isValidSaddleType ? saddleType : "thoroughbred"];
      const hasColors = colors && number in colors;

      // @ts-ignore
      const saddleColor = hasColors ? colors[number].saddleColor : "#C0C0C0";
      // @ts-ignore
      const numberColor = hasColors ? colors[number].numberColor : "#FFFFFF";

      return {
        number,
        saddleColor,
        numberColor
      };
    })
  );
};

export const exoticLabels: { [key: number]: string } = {
  0: "1st",
  1: "2nd",
  2: "3rd"
};

export const getPayoffSelectionLabel = (
  index: number,
  isPick: boolean,
  raceNumber: number,
  payoffsLength: number
) => {
  const exoticLabel = index >= 3 ? `${index + 1}th` : exoticLabels[index];
  const pickLabel = `R${raceNumber + (index + 1) - payoffsLength}`;

  return isPick ? pickLabel : exoticLabel;
};
